import styled, { css } from "styled-components";

import { colorsPalettes, mixins } from "@similarweb/styles";

import {
    StyledLeadsPageIconWrapper,
    StyledLeadsPageTitleWrapper,
} from "app/pages/sales-intelligence/common-components/layout";
import { withSWReactIconFillColor } from "app/pages/sales-intelligence/common-components/styles";
import { StyledTimeContainer } from "app/pages/sales-intelligence/pages/management/components/Management/styles";
import AutoCreatedTag from "app/pages/sales-intelligence/sub-modules/opportunities/components/list-items/AutoCreatedTag/AutoCreatedTag";
import { StyledAutoCreatedText } from "app/pages/sales-intelligence/sub-modules/opportunities/components/list-items/AutoCreatedTag/styles";
import ListsDropdownContainer from "app/pages/sales-intelligence/sub-modules/opportunities/components/top-section/ListsDropdown/ListsDropdownContainer";

export const StyledAutoCreatedTag = styled(AutoCreatedTag)`
    border: 1px solid transparent;
    margin-right: 8px;
`;

export const StyledLeadsPageTitle = styled.h1`
    ${mixins.setFontVariant("h5", colorsPalettes.carbon[500])};
    margin: 0;
    max-width: 100%;
`;

export const StyledPageTitleButton = styled(StyledLeadsPageTitleWrapper)<{ withHover: boolean }>`
    ${({ withHover }) =>
        withHover &&
        css`
            &:hover {
                color: ${colorsPalettes.blue[400]};
                background-color: ${colorsPalettes.bluegrey[200]};

                cursor: pointer;

                ${StyledLeadsPageTitle}, ${StyledTimeContainer}, ${StyledAutoCreatedText} {
                    color: currentcolor;
                }

                ${StyledLeadsPageTitle}, ${StyledLeadsPageIconWrapper} {
                    border-color: currentcolor;
                }

                ${StyledAutoCreatedTag} {
                    border-color: ${colorsPalettes.bluegrey[300]};
                }

                ${withSWReactIconFillColor("currentColor")}
            }
        `}
`;

export const StyledPageTitleDropdown = styled(ListsDropdownContainer)`
    flex-grow: 0;
`;
